<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateFarm"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.general_information')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @fillFertilizationApplicationForm="
                fillFertilizationApplicationForm
              "
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('fertilization.fertilizers')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @on-validated="onStepValidated"
              @fillFertilizationApplicationForm="
                fillFertilizationApplicationForm
              "
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center text-muted">
              3.1 {{ $t('common_words.verify_inputed_information') }}
            </p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-9">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.year') }}:</strong>
                        </h6>
                        {{ fertilizationApplicationForm.date }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{
                              $t('fertilization.fertilizing_type')
                            }}
                            :</strong
                          >
                        </h6>
                        {{ fertilizationApplicationForm.type }}
                      </td>
                    </tr>
                    <tr
                      class="shadow-sm"
                      v-if="fertilizationApplicationForm.farm"
                    >
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.farm') }}:</strong>
                        </h6>
                        {{ fertilizationApplicationForm.farm.name }}
                      </td>
                    </tr>
                    <tr
                      class="shadow-sm"
                      v-if="fertilizationApplicationForm.lot"
                    >
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.allotment') }}:</strong>
                        </h6>
                        {{ fertilizationApplicationForm.lot.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('production.hectares') }}:</strong>
                        </h6>
                        {{ fertilizationApplicationForm.hectares }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{ $t('fertilization.fertilizers') }}:</strong
                          >
                        </h6>
                        <br />
                        <ul
                          v-for="(
                            value, index
                          ) in fertilizationApplicationForm.fertilizers"
                          :key="index"
                        >
                          <li>
                            {{ $t('fertilization.fertilizer') }}:
                            {{ fertilizers_names[index] }}
                          </li>
                          <li>
                            {{ $t('production.bundle_quantity_hectare') }}
                            {{
                              formatNumber(
                                fertilizationApplicationForm.packages[index] /
                                  fertilizationApplicationForm.hectares
                              )
                            }}
                          </li>
                          <li>
                            {{ $t('production.bundle_quantity_total') }}
                            {{
                              formatNumber(
                                fertilizationApplicationForm.packages[index]
                              )
                            }}
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { showContinue } from 'src/util/Util.js';
import FirstStep from './steps/FirstStep.vue';
import Formatter from 'src/class/Formatter';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SecondStep from './steps/SecondStep.vue';

export default {
  components: {
    FirstStep,
    SecondStep,
  },

  data() {
    return {
      title: '',
      year: 0,
      fertilizationApplicationForm: {},
      fertilizers_names: [],
      all_fertilizers: [],
    };
  },

  mixins: [mixinMasters, MixinPermissions, MixinMenu],

  methods: {
    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    formatNumber(value) {
      return Formatter.formatNumber(value);
    },

    cleanAllSteps() {
      this.$refs.firstStep.model = {};
      this.$refs.secondStep.model = {
        fertilizers: [],
        packages: [],
        fertilization_application_details_ids: [],
        fertilization_application_details_ids_bck: [],
      };
    },

    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },

    fillFertilizationApplicationForm(ref) {
      this.fertilizationApplicationForm = Object.assign(
        {},
        this.fertilizationApplicationForm,
        this.$refs[ref].model
      );
      this.fertilizationApplicationForm.date = moment(
        String(this.fertilizationApplicationForm.date)
      ).format('YYYY-MM-DD');

      this.fertilizers_names = [];

      if (ref == 'secondStep') {
        this.fertilizationApplicationForm.fertilizers.forEach((elem) => {
          let index = this.all_fertilizers.findIndex(
            (tableRow) => tableRow.id === elem
          );
          this.fertilizers_names.push(this.all_fertilizers[index].name);
        });
      }
    },

    storeUpdateFarm() {
      this.showHideLoading(true);
      this.fertilizationApplicationForm.route =
        'fertilization/fertilization_application';

      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.fertilizationApplicationForm.id = JSON.parse(
            sessionStorage.getItem('editForm')
          ).id;
          Axios.updateMaster(this.fertilizationApplicationForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/fertilization/fertilization_application',
                'fertilizationApplicationForm'
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.fertilizationApplicationForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/fertilization/fertilization_application',
                'fertilizationApplicationForm'
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },

  created() {
    this.showHideLoading(true);
    Axios.getMasters('fertilization/fertilizers')
      .then((response) => {
        this.all_fertilizers = response.data.data;
        this.showHideLoading();
      })
      .catch((error) => this.showMessageErrors(error));
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
  },

  mounted() {
    this.selectedItemOnMenu('fertilization');
  },

  destroyed() {
    this.deselectedItemOnMenu('fertilization');
  },
};
</script>
